/* by.ysc hero — "Stay in touch" email reveal.
 *
 * The trigger button expands an inline newsletter field (Shopify's native
 * {% form 'customer' %}). On submit the page reloads, so we stash an "open"
 * flag in sessionStorage and re-open the panel on the next load to show the
 * server-rendered success/error message.
 */
class ByyscEmailReveal extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-signup-trigger]');
    this.panel = this.querySelector('[data-signup-panel]');
    if (!this.trigger || !this.panel) return;

    this.input = this.panel.querySelector('input[type="email"]');
    this.form = this.panel.querySelector('form');

    let reopen = false;
    try {
      reopen = sessionStorage.getItem('byysc-signup-open') === '1';
      if (reopen) sessionStorage.removeItem('byysc-signup-open');
    } catch (e) {
      /* sessionStorage unavailable — ignore */
    }
    if (reopen) this._open(false);

    this.trigger.addEventListener('click', () => this._toggle());

    if (this.form) {
      this.form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem('byysc-signup-open', '1');
        } catch (e) {
          /* ignore */
        }
      });
    }
  }

  _toggle() {
    if (this.panel.classList.contains('is-open')) this._close();
    else this._open(true);
  }

  _open(focus) {
    this.panel.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    if (focus && this.input) {
      window.requestAnimationFrame(() => this.input.focus());
    }
  }

  _close() {
    this.panel.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('byysc-email-reveal')) {
  customElements.define('byysc-email-reveal', ByyscEmailReveal);
}
